import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from '../Icon';

const ListWrapper = styled.ul`
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  display: flex;
  margin-left: 0 !important;
  flex-direction: row !important;

  li {
    padding-left: 0;
  }

  li:not(:last-child) {
    margin-right: 1.312rem;
  }

  @media (min-width: 990px) {
    li {
      padding: 0.515rem 0.515rem;
    }

    li:first-child {
      padding-left: 0;
    }
  }
`;

function SocialBranding({ list, color }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            social {
              twitter
              linkedIn
              youtube
            }
          }
        }
      }
    `
  );
  const { twitter, linkedIn, youtube } = site.siteMetadata.social;

  const socialMedia = {
    youtube: {
      name: 'youtube',
      url: `https://www.youtube.com/channel/${youtube}`,
    },
    linkedIn: {
      name: 'linkedIn',
      url: `https://www.linkedin.com/company/${linkedIn}`,
    },
    twitter: {
      name: 'twitter',
      url: `https://twitter.com/${twitter}`,
    },
  };

  return (
    <ListWrapper>
      {list.map(platform => (
        <li key={socialMedia[platform].name}>
          <a href={socialMedia[platform].url} rel="noreferrer" target="_blank" aria-label={`Follow us on ${socialMedia[platform].name}`}>
            <Icon name={socialMedia[platform].name} color={color} />
          </a>
        </li>
      ))}
    </ListWrapper>
  );
}

SocialBranding.defaultProps = {
  color: '#595959',
  list: ['youtube', 'linkedIn', 'twitter'],
};

SocialBranding.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
};

export default SocialBranding;
